import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Button,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { withMsal } from '@azure/msal-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FEATURE_FLAGS } from 'common/constants';
import DropdownItemWithAria from 'hoc/DropdownMenu/DropdownItemWithAria';
import withFeatureFlags from 'hoc/withFeatureFlags';
import withIdentityData from 'hoc/withIdentityData';
import withMemberData from 'hoc/withMemberData';
import withUnreadMessageCount from 'hoc/withUnreadMessageCount';
import MessageCenterLink from 'components/molecules/MessageCenterLink';
import { env$ } from 'services/subjects';
import {
  getPrimeLink,
  PrimeLandingPages,
  payspanLink,
  accessCardLink,
  getOptumLink,
  getNationsLink,
  getSSOFitnessLink,
  transportationLink,
} from 'services/ssoService';
import './NavMenu.scss';
import { AUDITEVENTTYPE } from 'services/trackService';
import { sendCustomEvent } from 'common/utility';
import configurationService from 'services/configurationService';
import { map } from 'rxjs';
import { usePoliciesData } from 'hooks/usePoliciesData';
import { AuditEvent } from 'types/track/AuditEventType';
import { MemberPortalConfigContext } from 'contexts/MemberPortalConfigContext';
import { trackCustomEvent } from 'utils/events';
import { useAdasMember } from 'hooks/useAdasMember';

const CM_UM_NOTIFICATIONS_FLAG = 'cm-um-notifications';
const HEALTH_RISK_ASSESSMENT = 'member-health-risk-assessment';

const NavMenu = (props) => {
  const [state, setState] = useState({
    collapsed: true,
    windowWidth: null,
    cmUmNotificationFlagEnabled: false,
    healthRiskAssessmentFeatureFlag: false,
    termed: props?.member?.termed,
  });
  const { policies } = usePoliciesData();
  const { member } = useAdasMember();
  const { termed } = state;
  const config = useContext(MemberPortalConfigContext);

  useEffect(() => {
    window.addEventListener('resize', setWindowWidth);
    setWindowWidth();
    const getFeatureFlagsSubscription = configurationService
      .getFeatureFlags$()
      .pipe(
        map((response) => response.response),
        map((flags) => {
          if (!flags) {
            flags = [];
          }

          var result = {};

          for (var i = 0; i < flags.length; i++) {
            result[flags[i].name] = flags[i].isActive;
          }

          return result;
        })
      )
      .subscribe(
        (featureFlags) => {
          setState((prevState) => ({
            ...prevState,
            cmUmNotificationFlagEnabled:
              featureFlags?.[CM_UM_NOTIFICATIONS_FLAG] || false,
            healthRiskAssessmentFeatureFlag:
              featureFlags?.[HEALTH_RISK_ASSESSMENT] || false,
          }));
        },
        (error) => {
          console.error(error);
        }
      );
    const envSubscription = env$.subscribe({
      next: (env) => setState((prevState) => ({ ...prevState, env })),
    });
    return () => {
      getFeatureFlagsSubscription?.unsubscribe();
      window.removeEventListener('resize', setWindowWidth);
      envSubscription?.unsubscribe();
    };
  }, []);

  function setWindowWidth() {
    setState((prevState) => ({ ...prevState, windowWidth: window.innerWidth }));
  }

  function isOpen() {
    if (state.windowWidth !== null && state.windowWidth >= 992) {
      return true;
    }
    return !state.collapsed;
  }

  function toggleNavbar() {
    setState((prevState) => ({
      ...prevState,
      collapsed: !prevState.collapsed,
    }));
  }

  function CollapseLinkItem({ children, disabled,...rest }) {
    return (
      <Link onClick={() => toggleNavbar()} {...rest}>
        <DropdownItemWithAria disabled={disabled}>{children}</DropdownItemWithAria>
      </Link>
    );
  }

  let alignmentWebSite = `https://${
    state.env === 'prod' ? 'www' : 'test'
  }.alignmenthealthplan.com`;

  let providerSearchSite =
    state.env === 'prod'
      ? 'https://providersearch.alignmenthealthplan.com'
      : 'https://ava-providersearch-wu-uat.azurewebsites.net';

  useEffect(() => {
    if (props.member) {
      setState((prevState) => ({
        ...prevState,
        termed: props.member.termed,
      }));
    }
  }, [props.member]);

  const PaymentsElements = ({ policies }) => {
    if (!policies) {
      return (
        <DropdownMenu>
          <CollapseLinkItem className="text-dark" to="/claims">
            View My Claims
          </CollapseLinkItem>
        </DropdownMenu>
      );
    }
    return (
      <DropdownMenu>
        <DropdownItemWithAria
          href={payspanLink}
          target='_blank'
          rel='noopener noreferrer'
          onClick={sendCustomEvent.bind(
            {},
            {
              eventType: AUDITEVENTTYPE.MemberPortalSSOtoPayspan,
            }
          )}
        >
          Pay My Premium
        </DropdownItemWithAria>
        <CollapseLinkItem className="text-dark" to="/claims">
          View My Claims
        </CollapseLinkItem>
      </DropdownMenu>
    );
  };

  const sendRideShareEvent = useCallback(() => {
    let enabledDateTimestamp = new Date(config?.memberPortalConfig?.americanLogisticsEnabledDate || Date.now()).getTime();
    enabledDateTimestamp = 'Invalid Date' === Date
    const isAmericanLogisticsEnabled = enabledDateTimestamp === 'Invalid Date' || enabledDateTimestamp <= Date.now() || false;
    if(isAmericanLogisticsEnabled) {
      trackCustomEvent({
        eventType: AuditEvent.MemberPortalSSOToAmericanLogistics});
      return;
    }
    trackCustomEvent({
      eventType: AuditEvent.MemberPortalSSOtoSaferide,
    });
  }, [config?.memberPortalConfig]);

  return (
    <header>
      <Navbar
        className="navbar-expand-lg navbar-toggleable-lg ng-white border-bottom box-shadow"
        light
        aria-label="Main navigation menus"
      >
        <Container>
          <Row className="flex-grow-1 d-lg-none">
            <Col
              xs="12"
              className="d-flex flex-grow-1 justify-content-between align-items-center pb-2 pt-2"
            >
              <img
                className="d-lg-none"
                src="img/logo.png"
                height={40}
                alt="Logo"
              />
              <MessageCenterLink
                unreadMessageCount={props.unreadMessageCount}
                disabled={termed}
              />
              <NavbarToggler
                onClick={toggleNavbar}
                className={`${state.collapsed ? '' : 'ahc--expanded'}`}
              />
            </Col>
            <Col
              xs="12"
              className={"d-flex d-lg-none flex-column align-items-stretch flex-grow-1 border-top pb-2 pt-2"}
            >
              <span className="bold-text">
                Welcome {props.member && props.member.first_name}
              </span>
              <span>
                <span className="bold-text">Member ID: </span>
                {props.identity && props.identity.memberId}
              </span>
              <span className="bold-text">
                {policies &&
                  policies.length &&
                  `${policies[0].policy_name}-${policies[0].policy_number}`}
              </span>
            </Col>
          </Row>
          <Collapse
            className="d-lg-inline-flex flex-lg-row-reverse row"
            isOpen={isOpen()}
            navbar
          >
            <ul className="navbar-nav flex-grow col-12 justify-items-between">
              <NavItem>
                <NavLink active onClick={() => toggleNavbar()} tag={Link} to="/">
                  Home
                </NavLink>
              </NavItem>
              <UncontrolledDropdown
                nav
                inNavbar
                disabled={termed}
                className={termed ? 'disabled-item' : ''}
              >
                <DropdownToggle nav>
                  Plan &amp; Benefits
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <CollapseLinkItem className="text-dark" to="/benefits">
                    Benefit Highlights
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <CollapseLinkItem className="text-dark" to="/id-card">
                    My ID Card
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={accessCardLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      sendCustomEvent({
                        eventType:
                          AUDITEVENTTYPE.MemberPortalViewMyAccessCardDropdown,
                      });
                      sendCustomEvent({
                        eventType: AUDITEVENTTYPE.MemberPortalSSOInComm,
                      });
                    }}
                  >
                    My ACCESS card balance
                  </DropdownItemWithAria>
                  {props.featureFlags[FEATURE_FLAGS.mailOrderOtcLink] && (
                    <>
                      <DropdownItem divider />
                      <DropdownItemWithAria
                        href={getNationsLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={sendCustomEvent.bind(
                          {},
                          {
                            eventType:
                              AUDITEVENTTYPE.MemberPortalSSOtoOTCMailOrder,
                          }
                        )}
                      >
                        Mail Order OTC
                      </DropdownItemWithAria>
                    </>
                  )}
                  {member?.instacartUrl && (
                    <>
                      <DropdownItem divider />
                      <DropdownItemWithAria
                        href={member.instacartUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={sendCustomEvent.bind(
                          {},
                          {
                            eventType:
                              AUDITEVENTTYPE.MemberPortalSSOtoInstacart,
                          }
                        )}
                      >
                        Shop Instacart
                      </DropdownItemWithAria>
                    </>
                  )}
                  <DropdownItem divider />
                  <CollapseLinkItem className="text-dark" to="/out-of-pocket">
                    Maximum Out-of-Pocket Expenses
                  </CollapseLinkItem>
                    <DropdownItem divider />
                    <DropdownItemWithAria
                    href={transportationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={sendRideShareEvent}>
                    Schedule Transportation
                    </DropdownItemWithAria>
                  {member?.hasOptumBehavioralHealth ? (
                    <>
                      <DropdownItem divider />
                      <DropdownItemWithAria
                        href={getOptumLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={sendCustomEvent.bind(
                          {},
                          {
                            eventType: AUDITEVENTTYPE.MemberPortalSSOtoOptum,
                          }
                        )}
                      >
                        Behavioral Health
                      </DropdownItemWithAria>
                    </>
                  ) : null}
                  {props.featureFlags[FEATURE_FLAGS.onepassSsoLink] && (
                    <>
                      <DropdownItem divider />
                      <DropdownItemWithAria
                        href={getSSOFitnessLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={sendCustomEvent.bind(
                          {},
                          {
                            eventType: AUDITEVENTTYPE.MemberPortalSSOFitness,
                          }
                        )}
                      >
                        Fitness
                      </DropdownItemWithAria>
                    </>
                  )}
                  </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown
                nav
                inNavbar
                disabled={termed}
                className={termed ? 'disabled-item' : ''}
              >
                <DropdownToggle nav>
                  Doctors &amp; Care
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <CollapseLinkItem
                    className="text-dark"
                    to="/urgent-care-appointment-form"
                  >
                    Access 24/7 Doctor
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={providerSearchSite}
                    target="_blank"
                    onClick={sendCustomEvent.bind(
                      {},
                      {
                        eventType: AUDITEVENTTYPE.MemberPortalFindAProvider,
                      }
                    )}
                  >
                    Find a provider
                  </DropdownItemWithAria>
                  {!props.featureFlags[FEATURE_FLAGS.disablePcpChange] && (
                    <>
                      <DropdownItem divider />
                      <CollapseLinkItem className="text-dark" to="/pcp-change">
                        Change My PCP
                      </CollapseLinkItem>
                    </>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  My Health
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  {termed ? (
                    <CollapseLinkItem className="text-dark" to="/virtual-care">
                      My Virtual Care
                    </CollapseLinkItem>
                  ) : (
                    <CollapseLinkItem
                      className="text-dark"
                      to="/health-summary"
                    >
                      My Health Summary
                    </CollapseLinkItem>
                  )}

                  {state.cmUmNotificationFlagEnabled && (
                    <>
                      <DropdownItem divider />
                      <CollapseLinkItem
                        className="text-dark"
                        to="/health-summary#caremanagement"
                      >
                        Care Management Letters
                      </CollapseLinkItem>
                      <DropdownItem divider />
                      <CollapseLinkItem
                        className="text-dark"
                        to="/health-summary#referrals"
                      >
                        Referral Notifications
                      </CollapseLinkItem>
                    </>
                  )}
                  {state.healthRiskAssessmentFeatureFlag &&
                    props.member?.isSNP && (
                      <>
                        <DropdownItem divider />
                        <CollapseLinkItem
                          className="text-dark"
                          to="/health-risk-assessment"
                        >
                          Health Risk Assessment
                        </CollapseLinkItem>
                      </>
                    )}
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown
                nav
                inNavbar
                disabled={termed}
                className={termed ? 'disabled-item' : ''}
              >
                <DropdownToggle nav>
                  Prescriptions
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItemWithAria
                    href={getPrimeLink(PrimeLandingPages.FINDAPHARMACY)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Find a Pharmacy
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={getPrimeLink(PrimeLandingPages.FINDADRUG)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={sendCustomEvent.bind(
                      {},
                      {
                        eventType: AUDITEVENTTYPE.MemberPortalSSOtoPrime,
                      }
                    )}
                  >
                    Find a Drug
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={getPrimeLink(PrimeLandingPages.PRESCRIPTIONHISTORY)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={sendCustomEvent.bind(
                      {},
                      {
                        eventType: AUDITEVENTTYPE.MemberPortalSSOtoPrime,
                      }
                    )}
                  >
                    See Prescription History
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/medicare-part-d`}
                    target="_blank"
                  >
                    Medicare Part D
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/determination-request`}
                    target="_blank"
                  >
                    Determination Request
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/redetermination-request`}
                    target="_blank"
                  >
                    Redetermination Request
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/medication-therapy-management`}
                    target="_blank"
                  >
                    Medication Therapy Management
                  </DropdownItemWithAria>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  Payments
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <PaymentsElements policies={policies} />
              </UncontrolledDropdown>
              <UncontrolledDropdown
                nav
                inNavbar
              >
                <DropdownToggle nav>
                  Forms &amp; Resources
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <CollapseLinkItem
                  to="/plan-documents"
                  className="'text-dark"
                  disabled={termed}>
                    Plan Documents
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <CollapseLinkItem
                    className="text-dark"
                    to="/explanation-of-benefits"
                  >
                    Explanation of Benefits (EOB)
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/rights-and-responsibilities`}
                    target="_blank"
                    disabled={termed}
                  >
                    Rights and Responsibilities
                  </DropdownItemWithAria>
                  <DropdownItem divider />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/member-services`}
                    target="_blank"
                    disabled={termed}
                  >
                    Member Services
                  </DropdownItemWithAria>
                  <DropdownItem divider disabled={termed} />
                  <DropdownItemWithAria
                    href={`${alignmentWebSite}/members/grievance-and-appeals`}
                    target="_blank"
                    disabled={termed}
                  >
                    Grievances and Appeals
                  </DropdownItemWithAria>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown
                nav
                inNavbar
                disabled={termed}
                className={termed ? 'disabled-item' : ''}
              >
                <DropdownToggle nav>
                  Contact Us
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <CollapseLinkItem className="text-dark" to="message-center">
                    My Message Center
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <CollapseLinkItem
                    className="text-dark"
                    to="/contact-us"
                    onClick={sendCustomEvent.bind(
                      {},
                      {
                        eventType: AUDITEVENTTYPE.MemberPortalViewCallUs,
                      }
                    )}
                  >
                    Call Us
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <CollapseLinkItem className="text-dark" to="/faq">
                    FAQs
                  </CollapseLinkItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown
                nav
                inNavbar
                className={`d-lg-none ${termed ? 'disabled-item' : ''}`}
                disabled={termed}
              >
                <DropdownToggle nav>
                  My Account
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    aria-label="Toggle Dropdown Arrow"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <CollapseLinkItem
                    className="text-dark"
                    to="/account-information"
                  >
                    My Information
                  </CollapseLinkItem>
                  <DropdownItem divider />
                  <CollapseLinkItem
                    className="text-dark"
                    to="/communication-preferences"
                  >
                    Communication Preferences
                  </CollapseLinkItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </ul>
            <Button
              className="d-lg-none flex-grow-1 m-4 pt-2"
              color="primary"
              onClick={(_) => {
                sendCustomEvent({
                  eventType: AUDITEVENTTYPE.MemberPortalLogOut,
                });
                props.msalContext.instance.logoutRedirect();
              }}
            >
              <h4>Log Out</h4>
            </Button>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default withFeatureFlags(
  withUnreadMessageCount(withMemberData(withIdentityData(withMsal(NavMenu))))
);
